export const FETCH_ADDRESS_REQUEST = 'FETCH_ADDRESS_REQUEST'
export const FETCH_ADDRESS_SUCCESS = 'FETCH_ADDRESS_SUCCESS'
export const FETCH_ADDRESS_FALIURE = 'FETCH_ADDRESS_FALIURE'
